import React, { forwardRef, useEffect, useState } from 'react';
import moment from 'moment';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import BootstrapTable from 'react-bootstrap-table-next';
import filterFactory, {
  // textFilter
  // selectFilter
} from 'react-bootstrap-table2-filter';
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css';
import paginationFactory from 'react-bootstrap-table2-paginator';
import { useUserContext } from '../../context/UserContext';
import webServices from '../../services/webServices';
// eslint-disable-next-line import/no-duplicates
import { AffiliatePaymentCommentsPopup as AffiliatePaymentPopup } from './modals/AffiliatePaymentCommentsPopup';
// eslint-disable-next-line import/no-duplicates
import { AffiliatePaymentCommentsPopup as CommentsAffiliatePaymentPopup } from './modals/AffiliatePaymentCommentsPopup';

import filterIcon from '../../adminAssets/images/aff_Filter.svg';
import checkIcon from '../../adminAssets/images/dashboard_check.svg';

// eslint-disable-next-line no-unused-vars
const AffiliatePaymentListComponent = forwardRef((props, ref) => {
  const { isUserReadOnly } = useUserContext();

  const { location } = props;
  const listType = location.pathname.split('/')[3].replace('payment-', '');

  const [dataList, setDataList] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [isPaymentPopupVisible, setIsPaymentPopupVisible] = useState(false);
  const [isCommentsPopupVisible, setIsCommentsPopupVisible] = useState(false);
  const [selectedPaymentId, setSelectedPaymentId] = useState(null);

  const handlePaymentPopupCloseEvent = () => setIsPaymentPopupVisible(false);
  const handleCommentsPopupCloseEvent = () => setIsCommentsPopupVisible(false);

  const handelPayNowBtnClickEvent = async (comments, bulkUpdate = false) => {
    const paymentIds = bulkUpdate || !selectedPaymentId ? selectedRows : [selectedPaymentId];

    const response = await webServices.payAffiliatePayment({ paymentIds, comments });
    if (response && response.success) {
      setDataList(prevData => prevData.filter(item => !paymentIds.includes(item.id)));
    }

    handlePaymentPopupCloseEvent();
  };

  const handelSaveCommentsBtnClickEvent = async (comments) => {
    const response = await webServices.saveAffiliatePaymentComments({ paymentId: selectedPaymentId, comments });
    if (response && response.success) {
      setDataList(prevData => prevData.map(item => {
        const tempItem = item;
        if (item.id === selectedPaymentId) {
          tempItem.remarks = comments
        }
        return tempItem;
      }));
    }

    handleCommentsPopupCloseEvent();
  };

  const handleAddCommentsBtnClick = paymentId => {
    setSelectedPaymentId(paymentId);
    setIsCommentsPopupVisible(true);
  };

  const bulkPayNowBtnClickHandler = () => {
    // A native confirm is deliberate here: this pays out every pending
    // affiliate at once and is not reversible, so it must block until the
    // admin answers.
    // eslint-disable-next-line no-alert
    if (window.confirm('Are you want to pay all payouts?')) {
      handelPayNowBtnClickEvent(null, true);
    }
  };

  const payNowBtnClickHandler = paymentId => {
    setSelectedPaymentId(paymentId);
    setIsPaymentPopupVisible(true);
  };

  const getTableColumns = () => {
    const allColumns = {
      affiliateId: {
        dataField: 'affiliate.id',
        text: 'Id',
        sort: true
      },
      affiliateName: {
        dataField: 'affiliate.name',
        text: 'Affiliate',
        sort: true,
        formatter: (rowContent, row) => (
          <>
            <img src={row['affiliate.profile_image'] === null ? `${process.env.REACT_APP_PIC_BASE_URL}no_Image.svg` : `${process.env.REACT_APP_PIC_BASE_URL}${row['affiliate.profile_image']}`} alt="" />
            <span className="name">{row['affiliate.name']}</span>
          </>
        )
      },
      location: {
        dataField: 'affiliate.location',
        text: 'Location',
      },
      transactionId: {
        dataField: 'transaction_id',
        text: 'Txn. ID',
      },
      sale: {
        dataField: 'total_sale',
        text: 'Sale',
        sort: true,
        formatter: (rowContent, row) => (<span className="green">${row.total_sale}</span>)
      },
      commission: {
        dataField: 'affiliate_commission',
        text: 'Commission',
        sort: true,
        formatter: (rowContent, row) => (<span className="purple">${row.affiliate_commission}</span>)
      },
      due_date: {
        dataField: 'due_date',
        text: 'Due Date',
        sort: true,
        formatter: (rowContent, row) => (row.due_date ? moment(row.due_date).format('DD/MM/YYYY') : '')
      },
      payment_date: {
        dataField: 'payment_date',
        text: 'Date Paid',
        sort: true,
        formatter: (rowContent, row) => (row.payment_date ? moment(row.payment_date).format('DD/MM/YYYY') : '')
      },
      comments: {
        dataField: 'remarks',
        text: 'Comments',
        formatter: (rowContent, row) => {
          if (isUserReadOnly) {
            return "NA";
          }

          return row.is_paid === 1 && row.remarks === null ? (
            <button type="button" className="btn addComment" onClick={() => handleAddCommentsBtnClick(row.id)}>
              <span className="add"><img src={filterIcon} alt='' /></span><span className="normal">Add Comments</span>
            </button>
          ) : (row.remarks);
        }
      },
      action: {
        dataField: 'action',
        text: 'Action',
        formatter: (rowContent, row) => {
          if (isUserReadOnly) {
            return "NA";
          }
          return row.is_paid === 0 ? (<button type="button" className="btn theme-btn" onClick={() => payNowBtnClickHandler(row.id)}>Pay Now</button>) : (<button type="button" className="btn green-btn">Paid</button>);
        }
      }
    };

    if (['overdue', 'upcoming'].includes(listType)) {
      return [
        allColumns.affiliateId,
        allColumns.affiliateName,
        allColumns.location,
        allColumns.transactionId,
        allColumns.sale,
        allColumns.commission,
        allColumns.due_date,
        allColumns.action
      ];
    }

    if (listType === 'future') {
      return [
        allColumns.affiliateId,
        allColumns.affiliateName,
        allColumns.location,
        allColumns.sale,
        allColumns.commission
      ];
    }

    if (listType === 'paid') {
      return [
        allColumns.affiliateId,
        allColumns.affiliateName,
        allColumns.location,
        allColumns.transactionId,
        allColumns.sale,
        allColumns.commission,
        allColumns.due_date,
        allColumns.payment_date,
        allColumns.comments
      ];
    }

    return [];
  };

  const selectRow = {
    mode: 'checkbox',
    clickToSelect: false,
    onSelect: (row, isSelect) => {
      if (!isSelect) {
        const removeItemIndex = selectedRows.indexOf(row.id);
        if (removeItemIndex !== -1) {
          const newUpdateArr = [...selectedRows];
          newUpdateArr.splice(removeItemIndex, 1);
          setSelectedRows(newUpdateArr);
        }

        return true;
      }

      if (row.is_paid === 0) {
        setSelectedRows(prevData => [...new Set([...prevData, row.id])]);
        return true;
      }
      return false;
    },
    onSelectAll: (isSelect, rows) => {
      if (!isSelect) {
        setSelectedRows([]);
        return [];
      }

      const rowsSelection = rows.filter(row => row.is_paid === 0).map(row => row.id);

      if (rowsSelection.length > 0) {
        setSelectedRows(rowsSelection);

        return rowsSelection;
      }

      return [];
    }
  };

  const defaultSorted = [
    {
      dataField: 'affiliate.name',
      order: 'asc'
    }
  ];

  const customTotal = (from, to, size) => (
    <span className="react-bootstrap-table-pagination-total">
      Showing {from} to {to} of {size} Results
    </span>
  );

  useEffect(() => {
    webServices.getAffiliatePaymentsList(listType).then((response) => {
      setDataList(response.data);
    });
  }, []);

  const paginationOptions = {
    paginationSize: 2,
    pageStartIndex: 1,
    alwaysShowAllBtns: true, // Always show next and previous button
    withFirstAndLast: false, // Hide the going to First and Last page button
    hideSizePerPage: true, // Hide the sizePerPage dropdown always
    hidePageListOnlyOnePage: true, // Hide the pagination list when only one page
    firstPageText: 'First',
    prePageText: 'Previous',
    nextPageText: 'Next',
    lastPageText: 'Last',
    nextPageTitle: 'First page',
    prePageTitle: 'Pre page',
    firstPageTitle: 'Next page',
    lastPageTitle: 'Last page',
    showTotal: true,
    paginationTotalRenderer: customTotal,
    disablePageTitle: false,
    sizePerPageList: [
      {
        text: '10',
        value: 10
      },
      {
        text: '15',
        value: 15
      },
      {
        text: 'All',
        value: 99999
      }
    ] // A numeric array is also available. the purpose of above example is custom the text
  };

  const tblProps = {
    bootstrap4: true,
    keyField: 'id',
    data: dataList,
    columns: getTableColumns(),
    filter: filterFactory(),
    pagination: paginationFactory(paginationOptions),
    noDataIndication: 'No record found!',
    striped: true,
    hover: true,
    condensed: true,
    defaultSorted,
    filterPosition: 'top'
  };

  if (['overdue', 'upcoming'].includes(listType)) {
    tblProps.selectRow = selectRow;
  }

  return (
    <>
      <div className="container-fluid right">
        <header>
          <div className="bakdrum">
            <a href="/">Admin /</a> <span>Dashboard</span>
          </div>
          <div className="d-flex header-right" />
        </header>
        <div className="mainBody_container">
          <h4 className='adminHead'>{listType} Payments</h4>

          {!isUserReadOnly && ['overdue', 'upcoming'].includes(listType) && (
            <div className="payNow">
              <button type="button" className="btn theme-btn" onClick={bulkPayNowBtnClickHandler} disabled={selectedRows.length === 0}><img className="mr-2" src={checkIcon} alt='' />Pay Now</button>
            </div>
          )}

          <BootstrapTable {...tblProps} />
        </div>
      </div>


      <AffiliatePaymentPopup
        modalStatus={isPaymentPopupVisible}
        handleClose={handlePaymentPopupCloseEvent}
        sendBtnHandler={handelPayNowBtnClickEvent}
      />

      <CommentsAffiliatePaymentPopup
        modalStatus={isCommentsPopupVisible}
        handleClose={handleCommentsPopupCloseEvent}
        sendBtnHandler={handelSaveCommentsBtnClickEvent}
        isCommentPopup
      />
    </>
  );
});

export default AffiliatePaymentListComponent;
